import { CartStore } from '@rc-d2c/context-manager';
import { useFormattedPrice, useIsFetchingCartPriceDetails } from '@rc-d2c/shared-behavior';
import { RcLoader } from '@rc-d2c/shared-ui';
import classnames from 'classnames/bind';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';

import styles from './CartTotalDetail.module.scss';

const cx = classnames.bind(styles);

export const CartTotalDetail = () => {
  const { t } = useTranslation();
  const { totalPriceWithoutDiscount, totalSubscriptionDiscountPrice, promotion, deliveryFees, shippingDiscount } = useStore(
    CartStore,
    (state) => state,
  );

  const { formatPrice } = useFormattedPrice();
  const isFetchingPrice = useIsFetchingCartPriceDetails();

  const formattedDeliveryFees = deliveryFees === 0 ? t('cart.cardTotal.offered') : formatPrice(deliveryFees);

  return (
    <section className={cx('cart-total-detail')}>
      <div className={cx('cart-total-detail__row')}>
        <p className={cx('cart-total-detail__row__text', 'cart-total-detail__row__sub-total')}>{t('cart.cardTotal.subTotal')}</p>
        <p data-testid="cart-total-detail-sub-total" className={cx('cart-total-detail__row__sub-total')}>
          {isFetchingPrice ? <RcLoader size={22} /> : formatPrice(totalPriceWithoutDiscount)}
        </p>
      </div>

      {/* Subscription */}
      {totalSubscriptionDiscountPrice > 0 && (
        <div className={cx('cart-total-detail__row')}>
          <p data-testid="cart-total-detail-subscription-text" className={cx('cart-total-detail__row__text')}>
            {t('cart.cardTotal.savedWithSubscription')}
          </p>
          <p data-testid="cart-total-detail-subscription-value" className={cx('cart-total-detail__row__value')}>
            {isFetchingPrice ? <RcLoader size={22} /> : `- ${formatPrice(totalSubscriptionDiscountPrice)}`}
          </p>
        </div>
      )}

      {/* Promo code */}
      {promotion?.discountPrice && promotion.discountPrice > 0 && (
        <div className={cx('cart-total-detail__row', { 'cart-total-detail__row': promotion && promotion.discountPrice })}>
          <p data-testid="cart-total-detail-promotion-text" className={cx('cart-total-detail__row__text')}>
            {promotion.marketingName}
          </p>
          <p data-testid="cart-total-detail-promotion-value" className={cx('cart-total-detail__row__value')}>
            {isFetchingPrice ? <RcLoader size={22} /> : `- ${formatPrice(promotion.discountPrice)}`}
          </p>
        </div>
      )}

      {/* Delivery fees / shipping discount */}
      {shippingDiscount > 0 ? (
        <>
          <div className={cx('cart-total-detail__row')}>
            <p data-testid="cart-total-detail-shipping-text" className={cx('cart-total-detail__row__text')}>
              {t('cart.cardTotal.shipping')}
            </p>
            <p data-testid="cart-total-detail-shipping-value">{isFetchingPrice ? <RcLoader size={22} /> : formatPrice(deliveryFees)}</p>
          </div>
          <div className={cx('cart-total-detail__row')}>
            <p data-testid="cart-total-detail-shipping-discount-text" className={cx('cart-total-detail__row__text')}>
              {t('cart.cardTotal.shippingDiscount')}
            </p>
            <p data-testid="cart-total-detail-shipping-discount-value" className={cx('cart-total-detail__row__value')}>
              {isFetchingPrice ? <RcLoader size={22} /> : `- ${formatPrice(shippingDiscount)}`}
            </p>
          </div>
        </>
      ) : (
        <div className={cx('cart-total-detail__row')}>
          <p data-testid="cart-total-detail-delivery-text" className={cx('cart-total-detail__row__text')}>
            {t('cart.cardTotal.deliveryFees')}
          </p>
          <p data-testid="cart-total-detail-delivery-value" className={cx({ 'cart-total-detail__row__value': deliveryFees === 0 })}>
            {isFetchingPrice ? <RcLoader size={22} /> : formattedDeliveryFees}
          </p>
        </div>
      )}
    </section>
  );
};
